import React, { useContext, useEffect, useMemo, useState } from 'react';
import { CustomerServiceDashboardContext } from '../../context/CustomerServiceDashboardContext';
import styles from './AccountList.module.scss';
import classNames from 'classnames/bind';
import { BsChevronDown } from '@react-icons/all-files/bs/BsChevronDown';
import Account = Mri.Accounts.Account;
import { BsChevronUp } from '@react-icons/all-files/bs/BsChevronUp';
import { AccountDetails } from '../AccountDetails';
import {useCustomerServiceDashboardStore} from "../../store";

const classes = classNames.bind(styles);
/**
 * Memoize AccountDetails component to prevent re-rendering when the parent component re-renders
 */
// const MemoizedAccountDetails = React.memo(AccountDetails);

export const AccountList = () => {
    // const { state, dispatch } = useContext(CustomerServiceDashboardContext);
    const [selectedAccounts, setSelectedAccounts] = useState<Account[]>([]);
    const { accounts, accountsVisibleToUser, loading, fetchAllAccounts } = useCustomerServiceDashboardStore();
    const isLoading = loading.accounts;
    useEffect(() => {
        fetchAllAccounts();
    }, [fetchAllAccounts]);
    const toggleAccount = (account: Account) => {
        const index = selectedAccounts.indexOf(account);
        if (index > -1) {
            selectedAccounts.splice(index, 1);
        } else {
            selectedAccounts.push(account);
        }
        setSelectedAccounts([...selectedAccounts]);
    };
    const TitleRow = (
        <div key={`account--title-row`} className={classes('account')}>
            <div className={classes('account-title', 'header-row')}>
                <div className={classes('row-number')}>#</div>
                <div className={classes('account-name')}>Account Name</div>
                <div className={classes('account-number')}>Account Number</div>
                <div className={classes('chevron')} />
            </div>
        </div>
    );
    const Rows = useMemo(() => {
        let rowNumber = 1;
        return (
            <>
                {accounts.map((account: any) => {
                    if (!account.active) return;
                    const selected = selectedAccounts.indexOf(account) > -1;
                    return (
                        <div key={`account-${account.id}--${rowNumber}`} className={classes('account')}>
                            <div className={classes('account-title')} onClick={() => toggleAccount(account)}>
                                <div className={classes('row-number')}>{rowNumber++}</div>
                                <div className={classes('account-name')}>{account.accountName}</div>
                                <div className={classes('account-number')}>{account.accountNumber}</div>
                                <span>
                                    {selected ? <BsChevronUp className={classes('chevron')} /> : <BsChevronDown />}
                                </span>
                            </div>
                            {selected && (
                                <AccountDetails
                                    className={classes('account-details')}
                                    accountNumber={account.accountNumber}
                                    accountDetails={account}
                                />
                            )}
                        </div>
                    );
                })}
            </>
        );
    }, [accounts, selectedAccounts]);
    return (
        <div className="grid-table table">
            {TitleRow}
            {accounts && Rows}
            {/* {accounts.length === 0 && <div>No accounts</div>} */}
        </div>
    );
};
